import { render } from "./AddArtItem.vue?vue&type=template&id=1641e89a&scoped=true"
import script from "./AddArtItem.vue?vue&type=script&lang=js"
export * from "./AddArtItem.vue?vue&type=script&lang=js"

import "./AddArtItem.vue?vue&type=style&index=0&id=1641e89a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1641e89a"

export default script